function serialize(value) {
  if (value === null || value === undefined) {
    return ''
  } else if (Array.isArray(value)) {
    return value.join('')
  } else {
    return `${value}`
  }
}

/**
 * Concats a template literal and interpolates values correctly, as well as removes formatting whitespace and HTML comments
 * Does not output null or undefined.
 * Concatenates lists with no comma.
 */
export function html(strings, ...interpolations) {
  let str = strings[0]
  for (let i = 0; i < interpolations.length; i++) {
    str += serialize(interpolations[i])
    str += strings[i + 1]
  }

  return str.replace(/>\s+</g, '><').replace(/<!--(.|\s)*?-->/, '')
}
